import { useOcrContext } from '@/features/InvoiceReport/Edit/components/Context/OcrContext';
import { OcrReflectionDrawer } from '@/features/InvoiceReport/Edit/components/Drawer/OcrReflectionDrawer';
import { ProcessOcrInferenceLoading } from '@/features/InvoiceReport/Edit/components/ProcessOcrInferenceLoading';
import { InferenceAlerts } from '@/features/InvoiceReport/Edit/components/ReportFormInputs/ReportFormInputs';
import { type useFillPaymentRequestDetails } from '@/features/InvoiceReport/Edit/components/hooks/useFillPaymentRequestDetails';
import { type useFillPaymentRequestSummary } from '@/features/InvoiceReport/Edit/components/hooks/useFillPaymentRequestSummary';
import { OcrInferenceResult } from '@/features/InvoiceReport/Edit/components/type';
import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { FC } from 'react';
import { Control } from 'react-hook-form';

type Props = {
  bookDateInputId?: string;
  dueDateInputId?: string;
  payeeInputId?: string;
  canDisplayDrExcise?: boolean;
  willOverwriteTransactions?: boolean;
  draftInstantPayeeBankName?: string;
  draftInstantPayeeBankBranchName?: string;
  ocrInferenceResult?: OcrInferenceResult | null;
  invoiceRegistrationNumberKey?: string;
  isHiddenInvoiceRegistrationNumber?: boolean;
  isActiveInstantPayee?: boolean;
  isEnabledInstantPayee?: boolean;
  fillPaymentRequestSummary: ReturnType<typeof useFillPaymentRequestSummary>;
  fillPaymentRequestDetails: ReturnType<typeof useFillPaymentRequestDetails>;
  control: Control<PaymentRequestForm>;
  isDutyFree: boolean;
  inferenceAlerts?: InferenceAlerts;
};

export const OcrInferenceComponent: FC<Props> = ({
  bookDateInputId,
  dueDateInputId,
  payeeInputId,
  willOverwriteTransactions,
  invoiceRegistrationNumberKey,
  isHiddenInvoiceRegistrationNumber,
  isActiveInstantPayee,
  isEnabledInstantPayee,
  canDisplayDrExcise,
  draftInstantPayeeBankName,
  draftInstantPayeeBankBranchName,
  fillPaymentRequestSummary,
  fillPaymentRequestDetails,
  control,
  isDutyFree,
  inferenceAlerts,
}: Props) => {
  const {
    currentInvoiceFile,
    ocrInferenceResult,
    isProcessOcrInferenceLoading,
    isNewFileUpload,
    isOcrInferenceDrawerVisible,
    setOcrInferenceResult,
    aiProgressType,
  } = useOcrContext();

  return (
    <>
      <ProcessOcrInferenceLoading
        isLoading={isProcessOcrInferenceLoading}
        isNewFileUpload={isNewFileUpload}
        aiProgressType={aiProgressType}
      />
      <OcrReflectionDrawer
        isVisible={isOcrInferenceDrawerVisible}
        bookDateInputId={bookDateInputId}
        dueDateInputId={dueDateInputId}
        payeeInputId={payeeInputId}
        invoice={currentInvoiceFile}
        ocrInferenceResult={ocrInferenceResult}
        invoiceRegistrationNumberKey={invoiceRegistrationNumberKey}
        draftInstantPayeeBankName={draftInstantPayeeBankName}
        draftInstantPayeeBankBranchName={draftInstantPayeeBankBranchName}
        willOverwriteTransactions={willOverwriteTransactions}
        canDisplayDrExcise={canDisplayDrExcise}
        isHiddenInvoiceRegistrationNumber={isHiddenInvoiceRegistrationNumber}
        isActiveInstantPayee={isActiveInstantPayee}
        isEnabledInstantPayee={isEnabledInstantPayee}
        setOcrInferenceResult={setOcrInferenceResult}
        fillPaymentRequestSummary={fillPaymentRequestSummary}
        fillPaymentRequestDetails={fillPaymentRequestDetails}
        control={control}
        isDutyFree={isDutyFree}
        inferenceAlerts={inferenceAlerts}
      />
    </>
  );
};
OcrInferenceComponent.displayName = 'OcrInferenceComponent';
